import { Controller } from "@hotwired/stimulus";

// Hides the wrapped element while any [data-hides-navbar-cta] marker on the
// page is in the viewport. Used so the navbar's "Get started" button doesn't
// duplicate the hero's CTA on the home page; reappears (desktop only) on
// scroll past the hero, and is always visible on pages without a marker.
export default class extends Controller {
  connect() {
    const marker = document.querySelector("[data-hides-navbar-cta]");
    if (!marker) return;

    // A marker only exists on the home page, where the navbar CTA surfaces
    // after scrolling past the hero. Keep it off mobile — the navbar is
    // already tight there — and let it appear from lg up.
    this.element.classList.add("max-lg:hidden");

    // Sticky navbar covers the top of the viewport, so shrink the observation
    // area by its height — the hero CTA is "out of view" once it slides under.
    const navbarHeight = document.querySelector("header")?.offsetHeight ?? 0;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.element.classList.toggle("hidden", entry.isIntersecting);
      },
      { threshold: 0, rootMargin: `-${navbarHeight}px 0px 0px 0px` },
    );

    this.observer.observe(marker);
  }

  disconnect() {
    this.observer?.disconnect();
  }
}
